import React from "react";

// Official HMMM MENU wordmark + app icon (assets in /public).
export function BrandLogo({ className = "h-8" }) {
  return <img src="/hmmm-logo.png" alt="HMMM MENU" className={`${className} w-auto object-contain`} />;
}

export function BrandIcon({ className = "h-9 w-9" }) {
  return <img src="/hmmm-icon.png" alt="HMMM MENU" className={`${className} rounded-xl object-cover`} />;
}

// Compact inline lockup (icon + wordmark text) for tight bars
export function BrandLockup({ className = "" }) {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <BrandIcon className="h-7 w-7" />
      <span className="font-head text-lg font-extrabold tracking-tight">
        HMMM<span className="hmmm-text"> MENU</span>
      </span>
    </span>
  );
}
